import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { ApplicationRoles } from './api-authorization/ApiAuthorizationConstants';

//import Modal from "react-bootstrap/Modal";
//import Row from "react-bootstrap/Row";
//import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";

import teamsService from '../services/TeamsService';
import authorizeService from './api-authorization/AuthorizeService';

const TeamMatchStats = (props) => {

    const { teamId } = useParams();

    const [userRole, setUserRole] = useState(null);
    const [teamDetails, setTeamDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userRole) {
            authorizeService.getUserRole().then((role) => {
                setUserRole(role);
            });
        }
    }, []);

    useEffect(() => {
        if (!teamDetails) {
            teamsService.getTeamStats(teamId).then((details) => {
                setTeamDetails(details);
                setLoading(false);
            });
        }
    }, []);

    const renderTable = (teamDetails) => {
        const isManager = userRole === ApplicationRoles.Manager;

        const matchStats = teamDetails.matchStats;

        const content = !matchStats || matchStats.length == 0 ? (
            <tr className="p-2"><td colSpan="45" className="text-center">No Match Stats</td></tr>
        ) : (matchStats.map((x) => {

            if (x.stats) {
                return (
                    <tr key={x.fixtureId}>
                        <td>{x.fixtureName}</td>
                        <td>{x.fixtureDateString}</td>
                        <td>{x.homeTeamName}</td>
                        <td>{x.awayTeamName}</td>
                        <td>{x.result}</td>

                        <td>{x.stats.attack.cleanBreaks}</td>
                        <td>{x.stats.attack.defendersBeaten}</td>
                        <td>{x.stats.attack.runs}</td>
                        <td>{x.stats.attack.offload}</td>
                        <td>{x.stats.attack.carriesGainLine}</td>
                        <td>{x.stats.attack.carriesNotGainLine}</td>
                        <td>{x.stats.attack.carriesMetres}</td>
                        <td>{x.stats.attack.passes}</td>
                        <td>{x.stats.attack.turnoversConceded}</td>

                        <td>{x.stats.defence.tackles}</td>
                        <td>{x.stats.defence.missedTackles}</td>
                        <td>{x.stats.defence.turnoversWon}</td>

                        <td>{x.stats.scrums.scrumsWon}</td>
                        <td>{x.stats.scrums.scrumsSuccess}</td>
                        <td>{x.stats.scrums.scrumsLost}</td>

                        <td>{x.stats.kicking.conversionGoals}</td>
                        <td>{x.stats.kicking.missedConversionGoals}</td>
                        <td>{x.stats.kicking.penaltyGoals}</td>
                        <td>{x.stats.kicking.missingPenaltyGoals}</td>
                        <td>{x.stats.kicking.kicksFromHand}</td>

                        <td>{x.stats.lineouts.lineoutsWon}</td>
                        <td>{x.stats.lineouts.lineoutsSuccess}</td>
                        <td>{x.stats.lineouts.lineoutsLost}</td>
                        <td>{x.stats.lineouts.lineoutsWonSteal}</td>

                        <td>{x.stats.breakdown.rucksWon}</td>
                        <td>{x.stats.breakdown.rucksLost}</td>
                        <td>{x.stats.breakdown.rucksTotal}</td>

                        <td>{x.stats.breakdown.maulsWon}</td>
                        <td>{x.stats.breakdown.maulsLost}</td>
                        <td>{x.stats.breakdown.maulsWonTry}</td>
                        <td>{x.stats.breakdown.maulsWonPenalty}</td>
                        <td>{x.stats.breakdown.maulsTotal}</td>

                        <td>{x.stats.discipline.yellowCards}</td>
                        <td>{x.stats.discipline.redCards}</td>
                        <td>{x.stats.discipline.penaltiesConceded}</td>
                        <td>{x.stats.discipline.redCardSecondYellow}</td>

                        <td>{x.stats.possession.possessionFirstHalf}</td>
                        <td>{x.stats.possession.possessionSecondHalf}</td>
                        <td>{x.stats.possession.possession}</td>
                        <td>{x.stats.possession.possessionLast10Mins}</td>
                    </tr>
                );
            }
            else {
                return <tr key={x.fixtureId}>
                    <td>{x.fixtureName}</td>
                    <td>{x.fixtureDateString}</td>
                    <td>{x.homeTeamName}</td>
                    <td>{x.awayTeamName}</td>
                    <td>{x.result}</td>
                    <td colSpan="40">No Match Stats Available</td>
                </tr>
            }
        }));

        return (
            <>
                <div>
                    <label>Last updated: {teamDetails.lastUpdatedString}</label>
                </div>
                <div style={{ overflowY: 'scroll', overflowX: 'scroll', whiteSpace: 'nowrap', maxHeight: 'calc(100vh - 180px)'  }}>
                    <Table striped bordered hover className="react-bootstrap-table">
                        <thead>
                            <tr>
                                <th colSpan="5" className="text-center">Fixture Details</th>
                                <th colSpan="6" className="text-center">Attack</th>
                                <th colSpan="3" className="text-center">Defence</th>
                                <th colSpan="3" className="text-center">Carries</th>
                                <th colSpan="3" className="text-center">Scrums</th>
                                <th colSpan="5" className="text-center">Kicking</th>
                                <th colSpan="4" className="text-center">Lineouts</th>
                                <th colSpan="3" className="text-center">Rucks</th>
                                <th colSpan="5" className="text-center">Mauls</th>
                                <th colSpan="4" className="text-center">Discipline</th>
                                <th colSpan="4" className="text-center">Possession</th>
                            </tr>
                            <tr className="react-bootstrap-table-double">
                                <th>Fixture</th>
                                <th>Date</th>
                                <th>Home Team</th>
                                <th>Away Team</th>
                                <th>Result</th>

                                <th>Clean Breaks</th>
                                <th>Defenders Beaten</th>
                                <th>Runs</th>
                                <th>Offload</th>
                                <th>Passes</th>
                                <th>Turnovers Conceded</th>

                                <th>Tackles</th>
                                <th>Missed Tackles</th>
                                <th>Turnovers Won</th>

                                <th>Gain Line</th>
                                <th>Not Gain Line</th>
                                <th>Metres</th>

                                <th>Won</th>
                                <th>Success</th>
                                <th>Lost</th>

                                <th>Conversion Goals</th>
                                <th>Missed Conversion Goals</th>
                                <th>Penalty Goals</th>
                                <th>Missing Penalty Goals</th>
                                <th>Kicks From Hand</th>

                                <th>Won</th>
                                <th>Success</th>
                                <th>Lost</th>
                                <th>Won Steal</th>

                                <th>Rucks Won</th>
                                <th>Rucks Lost</th>
                                <th>Rucks Total</th>
                                <th>Mauls Won</th>
                                <th>Mauls Lost</th>
                                <th>Mauls Won Try</th>
                                <th>Mauls Won Penalty</th>
                                <th>Mauls Total</th>

                                <th>Yellow Cards</th>
                                <th>Red Cards</th>
                                <th>Penalties Conceded</th>
                                <th>RC 2nd Yellow</th>

                                <th>Possession</th>
                                <th>Possession 1st Half</th>
                                <th>Possession 2nd Half</th>
                                <th>Possession Last 10Mins</th>
                            </tr>
                        </thead>
                        <tbody>
                            {content}
                        </tbody>
                    </Table>
                </div>
            </>
        );
    };

    let title = loading ? <h1 id="tabelLabel">Team Match Stats</h1> : <h1 id="tabelLabel">{teamDetails.teamName}</h1>;
    let contents = loading ? <p><em>Loading...</em></p> : renderTable(teamDetails);

    return (
        <div>
            {title}

            {contents}
        </div>
    );
}

TeamMatchStats.displayName = TeamMatchStats.name;

export default TeamMatchStats;